import ServerError from './ServerError';
import NotFound from './NotFound';
import { Wrapper } from './styles';
import { Props } from './types';

const DEFAULT_TITLE = 'Something wrong here...';

const DEFAULT_MESSAGE =
  'Sorry, we’re unable to fetch model details at the moment';

function ErrorScreen({
  message = DEFAULT_MESSAGE,
  title = DEFAULT_TITLE,
  variant = 'error',
}: Props) {
  return (
    <Wrapper height="100">
      {(() => {
        switch (variant) {
          case 'not-found':
            return <NotFound />;
          default:
            return <ServerError />;
        }
      })()}
      <h3>{title}</h3>
      <p>{message}</p>
    </Wrapper>
  );
}

export default ErrorScreen;
